import { useQuery } from "@tanstack/react-query";
import { getTags } from "../../api/apiTags";
import i18next from "i18next";

export function useGetTags(params) {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ["tags", params, i18next.language],
        queryFn: () => getTags(params),
        keepPreviousData: true,
    });

    return {
        tags: data?.data || [],
        meta: data?.meta || {},
        error,
        isLoading,
        refetch
    };
}
